// global
import { useState, useEffect, useCallback } from 'react';
// utils
import { capitalize } from 'app/utils';

function useDefaultDropdown({ fetchData, initialOptions = [], dependencies = [] }) {
  const [state, setState] = useState({
    loading: false,
    options: initialOptions
  });

  useEffect(() => {
    setState(prevState => ({ ...prevState, loading: true }));

    fetchData().then(onLoadSuccess).catch(onLoadFail);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies]);

  const onLoadSuccess = useCallback(data => {
    const options = data.map(item => ({
      key: item.value,
      text: capitalize(item.text),
      value: item.value,
      addons: item.addons
    }));

    options.unshift({ text: '-', value: null });

    setState(prevState => ({
      ...prevState,
      loading: false,
      options
    }));
    // eslint-disable-next-line
  }, []);

  const onLoadFail = useCallback(() => {
    setState(prevState => ({
      ...prevState,
      loading: false,
      options: []
    }));
  }, []);

  return state;
}

export default useDefaultDropdown;
